import React from 'react';
import ComponentRegistry from "Fratello/Common/ComponentRegistry";

export default function PanelProductView({ title, image, pricing, matrix, onRemove }) {
    const Image = ComponentRegistry.get("Image");
    return (
        <div className="compare-item list-item col-md-3 col-xs-12">
            <div className="inner">
                <div className="product-image">
                    <Image className="img-fluid hidden-sm-down" src={image} />
                    <a className="btn btn-close" href="" onClick={event => {
                        event.preventDefault();
                        onRemove();
                    }}><i className="icon icon-close white"></i></a>
                </div>
                <p className="product-title text-xs-left text-center">{title}</p>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductCompare/Views/PanelProductView.jsx